export default __webpack_public_path__ + "static/media/Arrow 2 Up.fb51fd58.svg";